import { Component, Input } from '@angular/core';
import { RadioButtonItem } from 'source/app/objects/request/properties/radio-button-item';

@Component({
  templateUrl: './radio-button.html'  
})
export class RadioButtonComponent { 

    constructor() {
      this.DefaultItems = 
      [
        new RadioButtonItem(true, "Option 1", "Value1"),
        new RadioButtonItem(false, "Option 2", "Value2"),
        new RadioButtonItem(false, "Option 3 Disabled", "Value3", true),
      ]

      this.Theme1Items = 
      [
        new RadioButtonItem(true, "Option 1", "Value1"),
        new RadioButtonItem(false, "Option 2", "Value2"),
        new RadioButtonItem(false, "Option 3 Disabled", "Value3", true),
      ]

      this.Theme2Items = 
      [
        new RadioButtonItem(true, "Option 1", "Value1"),
        new RadioButtonItem(false, "Option 2", "Value2"),
        new RadioButtonItem(false, "Option 3 Disabled", "Value3", true),
      ]      
    }

    @Input() DefaultItems: Array<RadioButtonItem>;

    private defaultGroup: any;
    @Input('DefaultGroup')
    get DefaultGroup(): any {        
        return this.defaultGroup;
    }
  
    set DefaultGroup(value: any) {
        this.defaultGroup = value;

        for (var i=0; i<this.DefaultItems.length; i++) {
            var item = this.DefaultItems[i];
            item.IsChecked = this.defaultGroup == item.Value;
        }
    } 
    
    @Input() Theme1Items: Array<RadioButtonItem>;

    private theme1Group: any;
    @Input('Theme1Group')
    get Theme1Group(): any {        
        return this.theme1Group;
    }
  
    set Theme1Group(value: any) {
        this.theme1Group = value;

        for (var i=0; i<this.Theme1Items.length; i++) {
            var item = this.Theme1Items[i];
            item.IsChecked = this.theme1Group == item.Value;
        }
    }

    @Input() Theme2Items: Array<RadioButtonItem>;

    private theme2Group: any;
    @Input('Theme2Group')
    get Theme2Group(): any {        
        return this.theme2Group;
    }
  
    set Theme2Group(value: any) {
        this.theme2Group = value;

        for (var i=0; i<this.Theme2Items.length; i++) {
            var item = this.Theme2Items[i];
            item.IsChecked = this.theme2Group == item.Value;
        }
    }

}


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/test/views/home/radio-button/radio-button-component.ts